// Liste uçlarından gelen kayıtlar EN YENİ eklenen başta olacak şekilde sıralanır.
// Backend sıralama garantisi vermediği için sıra istemcide sabitlenir.

type Timestamped = {
  _id?: string;
  createdAt?: string;
  updatedAt?: string;
};

// Kaydın "eklenme zamanı" — sırasıyla createdAt, updatedAt ve son çare olarak
// Mongo ObjectId denenir (ilk 8 hex hane, saniye cinsinden oluşturulma zamanıdır).
const stampOf = (r: Timestamped): number => {
  for (const raw of [r.createdAt, r.updatedAt]) {
    if (!raw) continue;
    const t = Date.parse(raw);
    if (!Number.isNaN(t)) return t;
  }
  if (r._id && /^[0-9a-f]{24}$/i.test(r._id)) {
    return parseInt(r._id.slice(0, 8), 16) * 1000;
  }
  return 0;
};

/** Kopyasını döndürür: en yeni kayıt ilk sırada. */
export const newestFirst = <T extends Timestamped>(records: T[] | undefined) =>
  [...(records ?? [])].sort((a, b) => stampOf(b) - stampOf(a));
